import { render, staticRenderFns } from "./typecolor.vue?vue&type=template&id=03d3331c&"
import script from "./typecolor.vue?vue&type=script&lang=js&"
export * from "./typecolor.vue?vue&type=script&lang=js&"
import style0 from "./typecolor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports